import { CardList } from '../../../../../../../commonComponents/CardList';
import { OfficeList, OfficesHeader, OfficesSubHeader } from './components';

export const OfficesCard = () => (
  <CardList Header={OfficesHeader} SubHeader={OfficesSubHeader} List={OfficeList} />
);
